// Components==============
import React from 'react';
import { motion } from 'framer-motion';
import './index.module.scss';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import RichText from 'components/UI/RichText';
// =========================

export default function NewsCard({ image, title, created_at, id, content }) {
    const openNewsModal = useOpenUrlModal(`nieuws-popup/${id}`);

    return (
        <>
            <motion.div
                onClick={() => openNewsModal()}
                whileHover={{ scale: 1.025 }}
                whileTap={{ scale: 0.975 }}
                styleName="news"
            >
                <img src={image} alt="news" />
                <div styleName="info">
                    <p styleName="date">{created_at}</p>
                    <p styleName="title">{title}</p>
                    <RichText richText={eval(content)} description />
                </div>
            </motion.div>
        </>
    );
}
